import React from "react";
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from "./Redux/store";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.3.0";
import "assets/demo/demo.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import 'react-h5-audio-player/lib/styles.css';
import { getAuthToken } from './tokenHandler';
import App from './App';
import {BrowserRouter} from "react-router-dom";

const token = getAuthToken();
if (token) {
    const numberArray = localStorage.getItem('authToken').split(',').map(Number);
    const arrayBuffer = new Uint8Array(numberArray).buffer;
    const token = new TextDecoder().decode(arrayBuffer);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter>
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick={true}
                    rtl={false}
                    pauseOnFocusLoss={true}
                    draggable={true}
                    pauseOnHover={true}
                />
                <App />
            </PersistGate>
        </Provider>
    </React.StrictMode>
    </BrowserRouter>
);
